import React from "react";
import { Users, Book, TrendingUp, Award } from "react-feather";
import { RootStore, useAppSelector } from "../../../store/store";
import { Card } from "../../../shared/Card/Card";
import "./interviewUsersMetrics.scss";

const InterviewUsersMetrics = () => {
  const interviewUsersState = useAppSelector(
    (store: RootStore) => store.InterviewUsersSlice
  );
  const { loading, stats } = interviewUsersState;

  if (loading.fetchInterviewUsers) {
    return (
      <div className="metrics-loading">
        <div className="skeleton-card" />
        <div className="skeleton-card" />
        <div className="skeleton-card" />
        <div className="skeleton-card" />
      </div>
    );
  }

  return (
    <div className="interview-users-metrics">
      <Card>
        <div className="metric-item">
          <Users className="metric-icon blue" />
          <div>
            <p className="metric-label">Total Users</p>
            <p className="metric-value">{stats?.totalUsers ?? 0}</p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="metric-item">
          <Book className="metric-icon green" />
          <div>
            <p className="metric-label">Active Users</p>
            <p className="metric-value">{stats?.activeUsers ?? 0}</p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="metric-item">
          <TrendingUp className="metric-icon purple" />
          <div>
            <p className="metric-label">Avg Performance</p>
            <p className="metric-value">
              {`${Math.round((stats?.totalAvgPerformance ?? 0) * 10)}%`}
            </p>
          </div>
        </div>
      </Card>

      <Card>
        <div className="metric-item">
          <Award className="metric-icon orange" />
          <div>
            <p className="metric-label">Total Interviews</p>
            <p className="metric-value">{stats?.totalInterviews ?? 0}</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default InterviewUsersMetrics;

